// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__P8KSi","buttons":"SendReceipts_buttons__2LoyA","email":"SendReceipts_email__70PV-","bookApptTitle":"SendReceipts_bookApptTitle__1Ua9Q"};